module.exports = __webpack_public_path__ + "img/the-boleyn-inheritance.dc18b374.png";